
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
      required: false,
    },
    totalPages: {
      type: Number,
      default: 1,
      required: false,
    },
  },
  methods: {
    changePage(page) {
      if (page < 1) {
        return;
      }

      if (page > this.totalPages) {
        return;
      }

      this.$emit('update:currentPage', page);
    },
  },
};
